import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IBaselineAssesmentState, IBaselineQuestion, IBaselineResultsResponseType } from '@shared/models';
import { fetchAssesments, fetchAssesmentResults } from '../queries';

const state: IBaselineAssesmentState = {
    questions: [],
    submitData: {},
    averages: [],
    results: [],
    fetchingAssessmentResults: false,
    globalAverages: {
        activeCitizenship: 0,
        careerReadiness: 0,
        communication: 0,
        learning: 0,
        personalDevelopment: 0,
    },
    globalResults: {
        activeCitizenship: null,
        careerReadiness: null,
        communication: null,
        learning: null,
        personalDevelopment: null,
    },
    fetching: false,
};

const baselineAssesmentSlice = createSlice({
    name: 'platform-baselineAssesment',
    initialState: state,
    reducers: {
        setAssesmentQuestions: (state, { payload }: PayloadAction<IBaselineQuestion[]>) => {
            state.questions = payload;
        },
        setAssesmentResults: (state, { payload }: PayloadAction<IBaselineResultsResponseType['results']>) => {
            state.results = payload.attempts;
            state.averages = payload.averages;
            state.globalAverages = payload.globals?.averages;
            state.globalResults = payload.globals?.results;
        },
        updateSubmitData: (state, { payload }: PayloadAction<{ dataKey: string; value: number }>) => {
            state.submitData[payload.dataKey] = payload.value;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAssesments.pending, (state) => {
            state.fetching = true;
        });
        builder.addCase(fetchAssesments.rejected, (state) => {
            state.fetching = false;
        });
        builder.addCase(fetchAssesments.fulfilled, (state) => {
            state.fetching = false;
        });
        builder.addCase(fetchAssesmentResults.pending, (state) => {
            state.fetchingAssessmentResults = true;
        });
        builder.addCase(fetchAssesmentResults.rejected, (state) => {
            state.fetchingAssessmentResults = false;
        });
        builder.addCase(fetchAssesmentResults.fulfilled, (state) => {
            state.fetchingAssessmentResults = false;
        });
    },
});

export const { setAssesmentQuestions, updateSubmitData, setAssesmentResults } = baselineAssesmentSlice.actions;
export default baselineAssesmentSlice.reducer;
